import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { FullWidthBanner } from '@systemeio/components'
import { GrowthbookFlagsEnum } from 'growthbook/types'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { CONTENT_CLASSNAME } from 'shared/layout/constants/layout-class-names'

export const MaintenanceBanner = () => {
  const { t } = useLocoTranslation()

  const maintenanceWorkIsOn = useFeatureIsOn(GrowthbookFlagsEnum.MaintenanceWork)

  if (!maintenanceWorkIsOn) return null

  return (
    <FullWidthBanner contentClassName={CONTENT_CLASSNAME} variant="warning">
      {t('global.info_section_title_maintenance_work')}
    </FullWidthBanner>
  )
}
